<template>
  <b-card no-body>
    <b-row align-v="start">
      <b-col>
        <h4 class="pl-1 pt-1 d-inline-block pr-3">
          <span>
            {{ title }}
          </span>
        </h4>
        <span class="float-right mt-1 mr-1">
          <i :id="`info-${op.id}`" class="fa fa-lg fa-info"></i>
          <b-popover :target="`info-${op.id}`" triggers="hover" placement="bottom" :content="filtersToRepr" />
          <!-- <small class="mr-1">{{ filtersToRepr }}</small> -->
          <!-- <filter-op-modal :id="`filter-op-modal-${op.id}`" :defects="defects" @ok="handleOk"></filter-op-modal> -->
        </span>
      </b-col>
    </b-row>
    <span>
      <!-- <input type="text" class="custom-input d-inline-block float-right mt-1 mr-1" placeholder="DH (%)" v-model="dh" /> -->
    </span>
    <b-table striped hover :items="items" :fields="fields" small>
      <template #head(selected)>
        <b-form-checkbox v-model="allSelected"></b-form-checkbox>
      </template>
      <template #cell(acc)="{ index }">
        <span
          :class="{
            ['text-primary']: getAcc(index) <= op.quantity - op.completed_boxes,
            ['text-secondary']: getAcc(index) >= boxCapacity(capacity)
          }"
        >
          {{ getAcc(index) }}
        </span>
      </template>
      <template #cell(potential_boxes)="{ item, index }">
        <span
          :class="{
            ['text-primary']: getAcc(index) <= op.quantity - op.completed_boxes,
            ['text-secondary']: getAcc(index) >= boxCapacity(capacity)
          }"
        >
          {{ item.potential_boxes }}
        </span>
      </template>
      <template #cell(selected)="data">
        <b-form-checkbox v-model="data.item.selected" @change="handleCheckbox(data.item)"></b-form-checkbox>
      </template>
    </b-table>
  </b-card>
</template>

<script>
// import FilterOpModal from "./FilterOpModal";
import qimaDict from "../../../../lang/QIMA";
export default {
  name: "SelectedOp",
  data() {
    return {
      dh: null,
      allSelected: false,
      fields: [
        { key: "potential_kg", label: "OpKgP", class: "text-center" },
        { key: "potential_kg_after_dh", label: "KgP-Dh", class: "text-center" },
        { key: "potential_boxes", label: "Box(P)", class: "text-center" },
        { key: "acc", label: "Acc", class: "text-center" },
        { key: "selected", label: "", class: "text-center" }
      ]
    };
  },
  props: {
    op: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: "Restante"
    },
    items: {
      type: Array,
      default: () => []
    },
    capacity: {
      type: Number,
      default: 0
    },
    opTotal: {
      type: Number,
      default: 0
    },
    defects: {
      type: Object,
      default: () => {}
    },
    appliedDefectFilters: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    allSelected: function (val) {
      if (val) {
        this.bulkSelect();
      } else {
        this.unselectAll();
      }
    }
  },
  computed: {
    filtersToRepr() {
      let newFilters = [];
      for (let filter of this.appliedDefectFilters) {
        for (let def of filter) {
          console.log("ACAACK!!! 🐔", this.getQimaMeaning(def));
          newFilters.push(qimaDict[def]);
        }
      }
      return newFilters.join(", ");
    }
  },
  mounted() {
    this.dh = this.op.container.dh;
  },
  methods: {
    getQimaMeaning(key) {
      return qimaDict[key] || key;
    },
    handleOk(val) {
      const payload = {
        op: this.op.id,
        defects: val
      };
      this.$emit("ok", payload);
    },
    getKgDh(index) {
      return ((1 - this.dh / 100) * this.items[index].potential_kg).toFixed(2);
    },

    boxCapacity(kilograms) {
      return kilograms / this.op.container.net_weight;
    },
    getAcc(index) {
      // calculate acumulated net_kilograms from index 0 to current index
      return this.items.slice(0, index + 1).reduce((acc, item) => acc + Math.floor(item.potential_boxes), 0);
    },
    handleCheckbox(item) {
      const selectedItems = this.items.filter((item) => item.selected);
      const boxes = selectedItems.reduce((acc, item) => acc + Math.floor(item.potential_boxes), 0);
      const itemIndex = this.items.findIndex((i) => i.id === item.id);
      const pl = { op: this.op.id, item, itemIndex, boxes };
      this.$emit("update-selected", pl);
    },
    bulkSelect() {
      const remaining_boxes = this.op.remaining_boxes;
      const selectedItems = [];
      let boxes = 0;
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        const potential_boxes = Math.floor(item.potential_boxes);
        if (boxes + potential_boxes <= remaining_boxes && boxes + potential_boxes <= this.boxCapacity(this.capacity)) {
          item.selected = true;
          boxes += potential_boxes;
          selectedItems.push(item);
        } else {
          item.selected = false;
        }
      }
      this.$emit("update-selected", { op: this.op.id, items: selectedItems, boxes });
    },
    unselectAll() {
      this.items.forEach((item) => (item.selected = false));
      this.$emit("update-selected", { op: this.op.id, items: [], boxes: 0 });
    }
  }
};
</script>

<style scoped>
.btn-sm.xs {
  padding: 0.1rem 0.4rem;
}
.custom-input {
  /* border color red */
  border: 1px solid #c5c5c5;
  /* apply radious */
  border-radius: 3px;
}
</style>
